export default String.raw`
@charset "UTF-8";

@import 'globals/_global-variables';
@import 'globals/_globals2';
`